import cookie from './cookie';

export default function isAutomationEnvironment() {
  return !!cookie('disable-recaptcha').get();
}
